import createContentDeliveryApiClient from './createContentDeliveryApiClient.ts';
const getExpandedContent = async (contentId) => {
    const client = createContentDeliveryApiClient();
    const response = await client.get(`${encodeURIComponent(contentId)}`, {
        params: {
            expand: '*'
        }
    });
    return response.data;
};
export default getExpandedContent;
